module.exports = __webpack_public_path__ + "img/20190831140440839.8bc526bc.jpg";